import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import SessionRequestChapterAndDateForm from './SessionRequestChapterAndDateForm';
import SessionRequestConfirmationForm from './SessionRequestConfirmationForm';
import SessionRequestSuccess from './SessionRequestSuccess';
import { selectDefaultSource } from '../../../subscription/redux/selectors';
import Loading from '../Loading';
import UpdateBillingContent from '../UpdateBillingContent';

const getTextValues = name => ({
  'movement-specialist': {
    requestFormHeaderText: `Request a follow up session with ${name}`,
    confirmFormHeaderText: 'Confirm Follow-Up Purchase',
    successHeaderText: `Congratulations, you just booked a follow up session with ${name}`,
  },
  online: {
    requestFormHeaderText: 'Request an Online Follow-Up with Tathata',
    confirmFormHeaderText: 'Confirm Online Follow-Up Purchase',
    successHeaderText:
      "Congratulations, you just booked a follow-up online with Tathata! In the coming days, we'll email you with more information.",
    icon: 'Tathata-Logo',
  },
  'in-person': {
    requestFormHeaderText: 'Request an In-Person Follow-Up with Tathata',
    confirmFormHeaderText: 'Confirm In-Person Follow-Up Purchase',
    successHeaderText:
      "Congratulations, you just booked a follow-up in-person with Tathata! In the coming days, we'll email you with more information",
    icon: 'Tathata-Logo',
  },
});

class SessionRequestModal extends Component {
  static propTypes = {
    availability: PropTypes.string.isRequired,
    imageLocation: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    session: PropTypes.object.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['in-person', 'movement-specialist', 'online']).isRequired,
  };

  state = {
    note: '',
    page: 1,
    requestedDates: [{}],
    hours: 1
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.session.get('loading') && nextProps.session.get('loaded') && this.state.page === 2) {
      this.nextPage();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(reset('sessionRequestForm'));
  }

  nextPage = (values = {}) => {
    this.setState(state => Object.assign({ page: state.page + 1 }, values));
  };

  previousPage = () => {
    this.setState(state => ({ page: state.page - 1 }));
  };

  render() {
    const {
      availability,
      imageLocation,
      isMobile,
      name,
      onCancel,
      onSubmit,
      session,
      source,
      timeZoneId,
      type,
    } = this.props;
    const { page, requestedDates, note } = this.state;

    if (!source) {
      return <UpdateBillingContent />;
    }

    if (session.get('loading')) {
      return <Loading />;
    }

    const textValues = getTextValues(name);

    return (
      <div>
        {page === 1 && (
          <SessionRequestChapterAndDateForm
            availability={availability}
            imageLocation={imageLocation}
            initialValues={{ requestedDates, note }}
            headerText={textValues[type].requestFormHeaderText}
            onCancel={onCancel}
            onSubmit={this.nextPage}
            isMobile={isMobile}
            timeZoneId={timeZoneId}
            type={type}
            customIcon={textValues[type].icon}
            price={this.props.price}
          />
        )}
        {page === 2 && (
          <SessionRequestConfirmationForm
            headerText={textValues[type].confirmFormHeaderText}
            initialValues={{ requestedDates, note }}
            onCancel={this.previousPage}
            onSubmit={onSubmit}
            source={source}
            price={this.props.price}
            hours={this.state.hours}
            submitError={session.get('error')}
          />
        )}
        {page === 3 && (
          <SessionRequestSuccess
            headerText={textValues[type].successHeaderText}
            imageLocation={imageLocation}
            name={name}
            onClose={onCancel}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    source: selectDefaultSource(state),
    isMobile: state.browser.lessThan.desktop,
  };
};

export default connect(mapStateToProps)(SessionRequestModal);



// WEBPACK FOOTER //
// ./src/common/components/session-requests/SessionRequestModal.js